"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("@mui/material/Box"));

var _Menu = _interopRequireDefault(require("@mui/material/Menu"));

var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _reactI18next = require("react-i18next");

var _material = require("@mui/material");

var _styles = require("@mui/material/styles");

var _ExpandLess = _interopRequireDefault(require("@mui/icons-material/ExpandLess"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StyledBox = (0, _styles.styled)(_Box.default)(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    display: 'none'
  }, theme.breakpoints.down('sm'), {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center'
  });
});
var StyledLink = (0, _styles.styled)('a')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.palette.font.tertiary,
    textDecoration: 'none'
  };
});
var StyledIconButton = (0, _styles.styled)(_IconButton.default)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    ml: 2,
    borderRadius: '50%',
    color: 'white',
    border: "1px solid ".concat(theme.palette.font.tertiary),
    height: '20px',
    width: '20px'
  };
});

var MobileFooterItems = function MobileFooterItems() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var open = Boolean(anchorEl);

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledBox, null, /*#__PURE__*/React.createElement(_material.Typography, {
    color: "font.tertiary",
    variant: "body2",
    sx: {
      whiteSpace: 'nowrap'
    }
  }, "\xA9 2022 Attuned"), /*#__PURE__*/React.createElement(StyledIconButton, {
    onClick: handleClick,
    size: "small",
    sx: {
      marginLeft: '10px'
    },
    role: "button"
  }, /*#__PURE__*/React.createElement(_ExpandLess.default, {
    color: "secondary",
    fontSize: "small"
  }))), /*#__PURE__*/React.createElement(_Menu.default, {
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    onClick: handleClose,
    PaperProps: {
      elevation: 0,
      sx: {
        overflow: 'visible',
        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
        mt: 1.5,
        marginTop: '0px',
        '& .MuiAvatar-root': {
          width: 32,
          height: 32,
          ml: -0.5,
          mr: 1
        },
        '&:before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          bottom: 0,
          right: 5,
          width: 10,
          height: 10,
          bgcolor: 'background.paper',
          transform: 'translateY(-50%) rotate(45deg)',
          zIndex: 0
        }
      }
    },
    transformOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'top'
    }
  }, /*#__PURE__*/React.createElement(_MenuItem.default, null, /*#__PURE__*/React.createElement(StyledLink, {
    target: "_blank",
    href: t('URL_privacy_policy'),
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(_material.Typography, {
    variant: "body2"
  }, t('privacy')))), /*#__PURE__*/React.createElement(_MenuItem.default, null, /*#__PURE__*/React.createElement(StyledLink, {
    target: "_blank",
    href: t('URL_terms'),
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(_material.Typography, {
    variant: "body2"
  }, t('terms'))))));
};

var _default = MobileFooterItems;
exports.default = _default;